import React from 'react'

function Glasses() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <g>
                <path
                    fill="currentColor"
                    d="M20 12.709a4.383 4.383 0 00-4.375-4.376 4.25 4.25 0 00-1.308.2.433.433 0 01-.35-.05L11.8 7.075a.2.2 0 01-.092-.175.216.216 0 01.092-.175L15 4.642a.417.417 0 01.317-.042.391.391 0 01.258.192.833.833 0 101.442-.834 2.092 2.092 0 00-2.85-.741l-3.942 2.55a.433.433 0 01-.45 0L5.833 3.2a2.025 2.025 0 00-1.583-.208 2.075 2.075 0 00-1.283.966.833.833 0 101.441.834.392.392 0 01.259-.192.4.4 0 01.275 0L8.2 6.725A.217.217 0 018.269 7a.2.2 0 01-.07.075L6.034 8.483a.433.433 0 01-.35.05 4.375 4.375 0 103.067 4.35.408.408 0 01.2-.341c.323-.17.684-.257 1.05-.25.362-.009.72.074 1.042.242a.408.408 0 01.208.35 4.376 4.376 0 008.75-.175zM4.375 15.417a2.708 2.708 0 112.708-2.708 2.717 2.717 0 01-2.708 2.708zM10 10.625a3.907 3.907 0 00-1.283.2.417.417 0 01-.492-.2c-.139-.25-.3-.488-.483-.708a.417.417 0 01-.033-.491.408.408 0 01.124-.126l1.942-1.258a.433.433 0 01.45 0L12.167 9.3a.408.408 0 01.183.292.416.416 0 01-.092.325c-.182.22-.344.458-.483.708a.416.416 0 01-.492.2 3.908 3.908 0 00-1.283-.2zm5.625 4.792a2.709 2.709 0 112.708-2.708 2.716 2.716 0 01-2.708 2.708z"
                ></path>
            </g>
        </svg>
    )
}

export default Glasses
